/* eslint-disable */
import React, { Component } from "react";
import cookie from "react-cookies";
import axios from "axios";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { apiUrl, baseUrl } from "../Settings/Config";

import { showLoader, hideLoader, showAlert } from "../Settings/Settings";
var qs = require("qs");
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: {
        username: "",
        password: "",
      },
      error_msg: "",
    };
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "/assets/plugins/sidemenu/sidemenu.js";
    script.async = true;
    document.body.appendChild(script);

    const script2 = document.createElement("script");
    script2.src = "/assets/plugins/p-scroll/pscroll.js";
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.src = "/assets/js/custom.js";
    script3.async = true;
    document.body.appendChild(script3);
    $("#global-loader").fadeOut();
    $("body").addClass("login-img");
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { fields: { [field]: { $set: value } } }));
  };

  handleSignin = () => {
    const formPayload = this.state.fields;
    this.setState({ error_msg: "" });
    var postObject = {
      username: formPayload.username,
      password: formPayload.password,
    };
    showLoader("do_login", "class");

    axios.post(apiUrl + "users/login", qs.stringify(postObject)).then((res) => {
      if (res.data.status === "ok") {
        var ResulSet = res.data.result;
        cookie.save("userID", ResulSet.userID, {
          path: "/",
        });
        cookie.save("name", ResulSet.userFirstName, {
          path: "/",
        });
        cookie.save("accessToken", ResulSet.token, {
          path: "/",
        });
        cookie.save("userModule", ResulSet.userModule, {
          path: "/",
        });
        cookie.save("userType", ResulSet.userType, {
          path: "/",
        });
        var _$this = this;
        var redirectPage = ResulSet?.redirect || "";
        setTimeout(function () {
          hideLoader("do_login", "class");
          $("body").removeClass("login-img");
          if (redirectPage === "") {
            redirectPage = "dashboard";
          }
          window.location.href = baseUrl + redirectPage;
        }, 1000);
      } else {
        hideLoader("do_login", "class");
        showAlert("Error", res.data.message, "error");
      }
    });
  };
  /* signin - end*/

  render() {
    return (
      <div className="page">
        <div id="global-loader">
          <img
            src="../assets/images/loader.svg"
            className="loader-img"
            alt="Loader"
          />
        </div>
        <div className="container-login100">
          <div className="wrap-login100 p-6">
            <form className="login100-form validate-form">
              <span className="login100-form-title pb-5">
              ResMax Power Tech Pvt Ltd.
              </span>
              <span className="login100-form-title pb-5">Login</span>
              <div className="panel panel-primary">
                <Form
                  {...this.props}
                  fields={this.state.fields}
                  onChange={this.fieldChange}
                  onValid={this.handleSignin}
                  error_msg={this.state.error_msg}
                  onInvalid={() => console.log("Form invalid!")}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;

const isEmpty = (value) => (value === "" ? "This field is required." : null);

function validationConfig(props) {
  const { username, password } = props.fields;

  return {
    fields: ["username", "password"],

    validations: {
      username: [[isEmpty, username]],
      password: [[isEmpty, password]],
    },
  };
}

class Form extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgUsername = "";
    let errMsgPassword = "";

    if ($validation.username.error.reason !== undefined) {
      errMsgUsername = $validation.username.show && (
        <span className="error">{$validation.username.error.reason}</span>
      );
    }
    if ($validation.password.error.reason !== undefined) {
      errMsgPassword = $validation.password.show && (
        <span className="error">{$validation.password.error.reason}</span>
      );
    }

    return (
      <div className="panel-body tabs-menu-body p-0 pt-5">
        <div
          className="validate-input input-group"
          data-bs-validate="Valid email is required: ex@abc.xyz"
        >
          <a href={void 0} className="input-group-text bg-white text-muted">
            <i className="zmdi zmdi-email text-muted" aria-hidden="true"></i>
          </a>
          <input
            className="input100 border-start-0 form-control ms-0"
            type="text"
            placeholder="Enter Your Username"
            value={fields.username}
            {...$field("username", (e) => onChange("username", e.target.value))}
          />
          {errMsgUsername}
        </div>
        <div className="validate-input input-group" id="Password-toggle">
          <a href={void 0} className="input-group-text bg-white text-muted">
            <i className="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
          </a>
          <input
            className="input100 border-start-0 form-control ms-0"
            type="password"
            placeholder="Password"
            value={fields.password}
            {...$field("password", (e) => onChange("password", e.target.value))}
          />
          {errMsgPassword}
        </div>
        <div className="container-login100-form-btn">
          <a
            href={void 0}
            className="login100-form-btn btn-primary do_login"
            id="do_login"
            onClick={(e) => {
              e.preventDefault();
              this.props.$submit(onValid, onInvalid);
            }}
          >
            Login
          </a>
        </div>
      </div>
    );
  }
}
Form = validated(validationConfig)(Form);
